import React from "react";
import { Modal, Button } from "antd";
import styled from "styled-components";

const DeleteModal = ({
  visible,
  onConfirm,
  onCancel,
  loading = false,
  itemName = "this feed",
}) => {
  return (
    <Modal open={visible} onCancel={onCancel} footer={null} centered>
      <ModalWrapper>
        <h3>Confirm Deletion</h3>
        <p>Are you sure you want to delete {itemName}?</p>
        <div style={{ marginTop: 16, textAlign: "right" }}>
          <Button onClick={onCancel} style={{ marginRight: 8 }}>
            Cancel
          </Button>
          <Button type="primary" danger onClick={onConfirm} loading={loading}>
            Delete
          </Button>
        </div>
      </ModalWrapper>
    </Modal>
  );
};

export default DeleteModal;

const ModalWrapper = styled.div`
  width: 100%;

  h3 {
    font-size: 18px;
    font-weight: 600;
    font-family: "Poppins", sans-serif;
    margin: 0;
    margin-top: 10px;
  }

  p {
    font-family: "Poppins", sans-serif;
    margin: 0;
    margin-top: 10px;
  }

  button {
    font-family: "Poppins", sans-serif !important;
  }
`;
